module.exports = __webpack_public_path__ + "fonts/inter-v2-latin-700.woff?2ea3c06a57b0de51ea36cd45da121eaa";